export class ServiceEdgeRouterPolicy {
    name = '';
    edgeRouterRoles: any[] = [];
    serviceRoles: any[] = [];
    semantic = 'AnyOf';
    tags: any = {};
};